module.exports = __webpack_public_path__ + "img/bjtp.782fda0a.png";